import React, { useState,useEffect,useContext,useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from 'context/AuthProvider';
import moment from 'moment';
import { Button, Slider, Checkbox , Menu,Divider,Modal, Radio} from 'antd';
import DateRangePicker from 'components/UI/DatePicker/ReactDates';
import { LISTING_POSTS_PAGE } from 'settings/constant';
import {getLocalCurrency} from 'context/currency' ;
import {
  ComponentWrapper,
  RoomGuestWrapper,
  CenterWrapper,
  PriceRangeLabel,
  DateCategorieDayUseWrapper
} from './CategorySearch.style';
import { DEFAULT_FILTRE_PRICE, FORMAT_DATE_YMD, HORAIRE_DAY_USE, TITRE_LISTE_HOTEL, TITRE_OFFRE_MOMENT } from 'library/helpers/constUtils';
import MoneyFormat from 'components/UI/Money/MoneyFormat';
import useWindowSize from 'library/hooks/useWindowSize';
import { getCurrencyId } from 'library/helpers/fonction';
import { SharedDataContext } from 'context/SharedDataProvider';
import { LABEL_DAY_USE } from 'library/helpers/messages.label';
import { FaRegCalendar } from 'react-icons/fa';
import { RadioGroupSearch, SimpleDatePickerComponentWrapper, SimpleDatePickerFilterWrapper } from 'containers/Home/Search/Search.style';
import SingleDatePickerWrapper from 'components/UI/DatePicker/SingleDatePicker';

const calendarItem = {
  separator: '-',
  format: 'DD-MM-YYYY',
  locale: 'fr',
};

const CategorySearch = ({ defaultParamHotel,
  filtre,
  setTitle,
  setLoader,
  setHotelLoaded, 
  page, 
  size, 
  setDiplayLoadMoreBtn, 
  setparamFiltre, 
  setIsCurrentListFromFilter, 
  setIsOffreChecked, 
  isOffreChecked,
}) => {

  const {
    isFiltreDayUseChecked, 
    setIsFiltreDayUseChecked, 
    filtreDayUseDate,
    setFiltreDayUseDate,
    filtreDayUseMomentJournee,
    setFiltreDayUseMomentJournee
  } = useContext(SharedDataContext);


  let navigate = useNavigate();
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  let villeValue = urlParams.get('ville');
  let typeHotel = urlParams.get('hebergement');
  let listTypeHotel = [] ;
  if (typeHotel) listTypeHotel.push(parseInt(typeHotel));
  const [searchDate, setSearchDate] = useState(defaultParamHotel?.date_range??{
    setStartDate: null,
    setEndDate: null,
  }); 
  
  const [currency, setCurrency] = useState(getLocalCurrency());
  
  const [price, setPrice] = useState(defaultParamHotel?.price??{
    min: DEFAULT_FILTRE_PRICE[currency].min,
    max: DEFAULT_FILTRE_PRICE[currency].max,
    defaultMin: DEFAULT_FILTRE_PRICE[currency].min,
    defaultMax: DEFAULT_FILTRE_PRICE[currency].max,
  })

 
  const updateFiltre = (tableau,filtre) =>{
    const updatedTableau = tableau.map((item) => {
      if (filtre.includes(item.id)) {
        return { ...item, checked: true };
      } else {
        return { ...item, checked: false };
      }
    })
  
    return updatedTableau; 
  }
  
  const [equipementFiltre, setEquipementFiltre] = useState(filtre.equipement);
  const [proprieteFiltre, setproprieteFiltre] = useState(filtre.propriete);

  const [key, setKey] = useState(0); 
  const [sliderKey, setSliderKey] = useState(0);

  const onChange = (value, type) => {
    setPrice({
      ...price,
      min: value[0],
      max: value[1],
    })
    updatePriceLabel(value);
  };


  const {user} = useContext(AuthContext);
  
  const menuRef = useRef(null);
  let isClient = false ;
  let token = user?.token??null;
  if (user?.roles && user.roles.includes('ROLE_CLIENT')){
    isClient = true ;
  }


  const [windowScreenSize] = useState(useWindowSize());
  useEffect(() => {
    window.addEventListener('storage', () => {
      if(getLocalCurrency()){
        setCurrency(getLocalCurrency());
      } 
    });
    }, []);

    //update price
    useEffect(() => {
      setPrice(defaultParamHotel?.price??{
        min: DEFAULT_FILTRE_PRICE[currency].min,
        max: DEFAULT_FILTRE_PRICE[currency].max,
        defaultMin: DEFAULT_FILTRE_PRICE[currency].min,
        defaultMax: DEFAULT_FILTRE_PRICE[currency].max,
      })

    }, [currency, defaultParamHotel]);

    //update price label
    useEffect(() => {
      if (price) {
        updatePriceLabel([price?.min, price?.max]);
      }

    }, [price, windowScreenSize.width]);
  
  const getPriceValue = (values) => {
    if(Array.isArray(values) && values.length > 1) {
      return {
        min: {
          style: {
            left: "3%"
          },
          label:<PriceRangeLabel><MoneyFormat className='left-item' value={values[0]} suffix={` ${currency}`}/></PriceRangeLabel>,
        },
        max: {
          style: windowScreenSize?.width < 1500 ? {
            left: "85%"
          } : '',
          label:<PriceRangeLabel><MoneyFormat className='right-item' value={values[1]} suffix={` ${currency}`}/></PriceRangeLabel>,
        },
      }
    }
  }

  //update label price Init when user change the value
  const updatePriceLabel = (values) => {
    const priceValue = getPriceValue(values);
      setPriceInit({
        [DEFAULT_FILTRE_PRICE[currency].min]: priceValue?.min,
        [DEFAULT_FILTRE_PRICE[currency].max]: priceValue?.max
      })
  }

  //default display label price
  const defaulGettPrice = getPriceValue([DEFAULT_FILTRE_PRICE[currency].min, DEFAULT_FILTRE_PRICE[currency].max]);
  const [priceInit, setPriceInit] = useState({
    [DEFAULT_FILTRE_PRICE[currency].min]: defaulGettPrice?.min,
    [DEFAULT_FILTRE_PRICE[currency].max]: defaulGettPrice?.max
  });



  const [checked, setChecked] = useState([]);
  const checkEquipement = (e) => {
    const updatedList = [...checked];
    if (e.target.checked) {
      updatedList.push(e.target.value);
    } else {
      const index = updatedList.indexOf(e.target.value);
      if (index !== -1) {
        updatedList.splice(index, 1);
      }
    }
    setChecked(updatedList);
  };

  const [checkedPropriete, setcheckedPropriete] = useState(listTypeHotel);
  const checkPropriete = (e) => {
    var updatedList = [...checkedPropriete];
    if (e.target.checked) {
      updatedList = [...checkedPropriete,e.target.value];
    } else {
      updatedList.splice(updatedList.indexOf(e.target.value), 1);
    }
    setcheckedPropriete(updatedList);
  }
   
const [checkedListe, setcheckedListe] = useState({
      favoris : false,
      offres : isOffreChecked,
      dayUse: isFiltreDayUseChecked
    });
  const checkListe = (value,type) => {
    var res = {
      ...checkedListe,
      [type] : value}
    setcheckedListe(res);
  }



  const SubMenu = Menu.SubMenu;
  const MenuItem = Menu.Item;

  const modalError = (title, message) => {
    Modal.error({
      title: title,
      content: message,
      onOk() {
        return;
      }
    });
  };

  const onFavoris = () => {
    let title = TITRE_LISTE_HOTEL;
    let messageError = 'Ooups ! Une erreur est survenue';
    try {
      setLoader(true) ;
      fetch(`${process.env.REACT_APP_API_URL}/client/hotel-favoris`,
      {
        method : 'GET',
        headers : 
          token ? 
          {'Content-type': 'application/json',
           "Authorization": `Bearer ${user?.token}`
          } : 
          {'Content-type': 'application/json'}
      }).then(
        (res) =>
          res.json()
            .then((response => {
              setLoader(false) ;
              if (!res.ok) {
                modalError(title, response.message);
              }else {
                setHotelLoaded(response)
                //saveState("filtre", filter);
              }
            }))
            .catch(err => {
              setLoader(false) ;
              modalError(title, messageError);
            })
      ).catch(err => {
          setLoader(false) ;
          modalError(title, messageError);
      });
    }
    catch (e) {
      setLoader(false) ;
      modalError(title, messageError);
    }
  }

  const onFilter = () => {
    let title = TITRE_LISTE_HOTEL;
    let messageError = 'Ooups ! Une erreur est survenue';
    let endPointFilter = checkedListe.dayUse ?'hotels-day-use-filter':'hotels-filter';
   
    try {
      let paramFiltre = {};
      if(checkedListe.dayUse) {
        paramFiltre =  {
          "hotelCategories": checkedPropriete,
          "hotelEquipements": checked,
          "idDevise": getCurrencyId(currency), 
          "prixMin" : price.min,
          "prixMax": price.max,
          "idVille" : villeValue??null,
          "nombreChambre" : defaultParamHotel?.room??1,
          "nombreVoyageur" : defaultParamHotel?.guest??1,
          "offrePromo" : checkedListe.offres,
          "dayUse": checkedListe.dayUse,
          "date":filtreDayUseDate?.format(FORMAT_DATE_YMD),
          "momentJournee":filtreDayUseMomentJournee,
        };
      }else {
        paramFiltre =  {
          "dateDisponibiliteChambre": (searchDate.setStartDate && searchDate.setEndDate) ?  {
            "dateDepart": moment(searchDate.setStartDate,'DD-MM-YYYY').format('YYYY-MM-DD'),
            "dateEntree": moment(searchDate.setEndDate,'DD-MM-YYYY').format('YYYY-MM-DD')
          } : null,
          "hotelCategories": checkedPropriete,
          "hotelEquipements": checked,
          "idDevise": getCurrencyId(currency), 
          "prixMin" : price.min,
          "prixMax": price.max,
          "idVille" : villeValue??null,
          "nombreChambre" : defaultParamHotel?.room??1,
          "nombreVoyageur" : defaultParamHotel?.guest??1,
          "offrePromo" : checkedListe.offres,
          "dayUse": checkedListe.dayUse
        }
      }
      let api = {
        url : `${process.env.REACT_APP_API_URL}/${endPointFilter}?page=${page}&size=${size}`,
        method : 'POST',
        headers: token ? 
        {
          'Content-type': 'application/json',
          "Authorization": `Bearer ${user?.token}`
        } : 
        {'Content-type': 'application/json'}
        ,
        body : JSON.stringify(paramFiltre)
      }
    
      if (checkedListe.favoris){
        setTitle('Mes favoris');
        api = {
          url : `${process.env.REACT_APP_API_URL}/client/hotel-favoris`,
          method : 'GET',
          headers: {
            'Content-type': 'application/json',
            "Authorization": `Bearer ${user?.token}`
          },
          body : null
        }
      }

      setTitle(checkedListe.offres ? TITRE_OFFRE_MOMENT : TITRE_LISTE_HOTEL);
      setIsOffreChecked(checkedListe?.offres);
      setIsFiltreDayUseChecked(checkedListe?.dayUse);
      setLoader(true) ;
      // fetch(`${process.env.REACT_APP_API_URL}/hotels-filter`, {
      //   method: "POST",
      //   headers : {
      //     "Content-Type": "application/json"
      //   },
      //   body: JSON.stringify(paramFiltre),
      // }).then(
      fetch(api.url, {
        method: api.method,
        headers : api.headers,
        body: api.body,
      }).then(
        (res) =>
          res.json()
            .then((response => {
              setLoader(false) ;
              if (!res.ok) {
                modalError(title, response.message);
              }else {
                setHotelLoaded(Array.isArray(response) ? response : (response?.content ?? []));
                setDiplayLoadMoreBtn(Array.isArray(response) ? false :  !response.last);
                setparamFiltre(paramFiltre);
                setIsCurrentListFromFilter(true);
                //saveState("filtre", filter);
              }
            }))
            .catch(err => {
              setLoader(false);
              modalError(title, messageError);
            })
      ).catch(err => {
          setLoader(false) ;
          modalError(title, messageError);
      });
    }
    catch (e) {
      setLoader(false) ;
      modalError(title, messageError);
    }
  };

  const onSearchReset = () => {
    let title = TITRE_LISTE_HOTEL;
    let messageError = 'Ooups ! Une erreur est survenue';
    let paramFiltre = 
      {
        "dateDisponibiliteChambre": null,
        "hotelCategories": [],
        "hotelEquipements": [],
        "idDevise": getCurrencyId(), 
        "prixMin" : price.defaultMin,
        "prixMax": price.defaultMax,
        "idVille" : null,
        "nombreChambre" : 1,
        "nombreVoyageur" : 1,
        "offrePromo" : false,
        "dayUse": false
      }
    try {
      setLoader(true) ;
      fetch(`${process.env.REACT_APP_API_URL}/hotels-filter?page=${page}&size=${size}`, {
        method: "POST",
        headers : 
          token ? 
          {
            'Content-type': 'application/json',
            "Authorization": `Bearer ${user?.token}`
          } : 
          {'Content-type': 'application/json'}
          ,
        body : JSON.stringify(paramFiltre)
      }).then(
        (res) =>
          res.json()
            .then((response => {
              setLoader(false) ;
              if (!res.ok) {
                modalError(title, response.message);
              }else {
                setHotelLoaded(response?.content);
                setcheckedListe({
                  favoris : false,
                  offres : false,
                  dayUse: false
                });
                setPrice({min: price.defaultMin,
                  max: price.defaultMax,
                  defaultMin: price.defaultMin,
                  defaultMax: price.defaultMax,
                })
                setcheckedPropriete([]);
                setChecked([]);
                setKey(key + 1);
                setSliderKey(sliderKey + 1);
                const checkboxes = document.querySelectorAll('input[type="checkbox"]');
                checkboxes.forEach((checkbox) => (checkbox.checked = false));
                setDiplayLoadMoreBtn(!response.last);
                setSearchDate({
                  setStartDate: null,
                  setEndDate: null,
                });
                setTitle(TITRE_LISTE_HOTEL);
                navigate({pathname: LISTING_POSTS_PAGE })
              }
            }))
            .catch(err => {
              setLoader(false) ;
              modalError(title, messageError);
            })
      ).catch(err => {
          setLoader(false) ;
          modalError(title, messageError);
      });
    }
    catch (e) {
      setLoader(false) ;
      modalError(title, messageError);
    }
  };

  const cnhageAtae = (e) => {
    console.log(e);
  }

  return (
    <Menu mode="inline" >
    <Divider>Filtrer par :</Divider>
    {
      isClient ? 
      <MenuItem key="favoris" >
            <Checkbox onChange={event => checkListe(event.target.checked, 'favoris')} 
            value={checkedListe.favoris} checked={checkedListe.favoris}>
            <span>&nbsp;Mes favoris</span>
              </Checkbox>
      </MenuItem>
      : null
    }
    <MenuItem key="Day-use" >
          <Checkbox 
            onChange={
              event => {
                setIsFiltreDayUseChecked(event.target.checked);
                checkListe(event.target.checked, 'dayUse');
              }
            }
          value={checkedListe.dayUse} checked={checkedListe.dayUse}>
          <span>&nbsp;{ LABEL_DAY_USE }</span>
            </Checkbox>
    </MenuItem>
    {
      !isFiltreDayUseChecked &&
      <MenuItem key="Offre" >
        <Checkbox onChange={event => checkListe(event.target.checked, 'offres')}
          value={checkedListe.offres} checked={checkedListe.offres}>
          <span>&nbsp;Offres</span>
        </Checkbox>
      </MenuItem>
    }
    <SubMenu key="menu1" title={<span><span><b>Equipements</b></span></span>}>
      {equipementFiltre?.sort((equiA, equipB) => equiA.id - equipB.id).map((item, index) => (
        <MenuItem key={`Equipe${item.id}`} style={{"padding-left" : "25px"}}>
          <Checkbox onChange={checkEquipement} value={item.id}  checked={checked.includes(item.id)}  >
          <span>&nbsp;{item.libelle}</span>
            </Checkbox>
        </MenuItem>
      ))}
    </SubMenu>
    <SubMenu key="menu2" title={<span><span><b>Types d'hôtels</b></span></span>}>
    {proprieteFiltre?.sort((proprieteA, proprieteB) => proprieteA.id - proprieteB.id).map(item => (
        <MenuItem key={`Prop${item.id}`} style={{"padding-left" : "25px"}}>
          <Checkbox onChange={checkPropriete}  value={item.id}  checked={checkedPropriete.includes(item.id)} >
          <span>&nbsp;{item.libelle}</span>
            </Checkbox>
        </MenuItem>
      ))}
    </SubMenu>
    <SubMenu key="menu3" title={<span><span><b>Date</b><b></b></span></span>}>
    {checkedListe.dayUse &&
        <DateCategorieDayUseWrapper>
          <ComponentWrapper>
            <SimpleDatePickerFilterWrapper>
              <SingleDatePickerWrapper
                  placeholder='Date'
                  showClearDate={true}
                  numberOfMonths={1}
                  format={'DD-MM-YYYY'}
                  className='datePickerDayUseSearch'
                  updateDate={setFiltreDayUseDate}
                  initialDate={filtreDayUseDate}
                />
              </SimpleDatePickerFilterWrapper>
        </ComponentWrapper>
        <ComponentWrapper>
          <RadioGroupSearch>
            <Radio.Group
                  options={HORAIRE_DAY_USE}
                  onChange={(e)=>setFiltreDayUseMomentJournee(e.target.value)}
                  defaultValue={filtreDayUseMomentJournee}
                  optionType="default"
                  buttonBg='red'
                  buttonStyle="solid"
                />
          </RadioGroupSearch>
        </ComponentWrapper>
      </DateCategorieDayUseWrapper>
      }
      {!checkedListe.dayUse &&
        <ComponentWrapper>
        <DateRangePicker
          item={calendarItem}
          startDateId="startDate-id-category"
          endDateId="endDate-id-category"
          startDatePlaceholderText = "Arrivée"
          endDatePlaceholderText = "Départ"
          key={key} // Changez la clé d'élément pour forcer la réinitialisation
          startDate={
           searchDate?.setStartDate
              ? moment(searchDate.setStartDate,'DD-MM-YYYY')
              : null
          }
          endDate={
            searchDate?.setEndDate
              ? moment(searchDate.setEndDate,'DD-MM-YYYY')
              : null
          }
          numberOfMonths={2}//{width > 600 ? 2 : 1}
          small={true}
          updateSearchData={(value) => setSearchDate(value)}
        />
        </ComponentWrapper>
      }
    </SubMenu>
    <SubMenu key="menu4" title={<span><span><b>Prix</b></span></span>}>
      <RoomGuestWrapper>
        <Slider className='slider_cls'
                key={sliderKey}
                range
                marks={priceInit}
                step={10}
                min={price.defaultMin}
                max={price.defaultMax}
                value={[price.min, price.max]}
                defaultValue={[price.min, price.max]}
                tooltip={{open: false}}
                onChange={(value) => onChange(value, 'price')}
        />
      </RoomGuestWrapper>
    </SubMenu>
    <CenterWrapper>
      <Button onClick={onFilter} className='filter-btn'>
          Filtrer
          </Button>
      <Button onClick={onSearchReset}>
          Réinitialiser
      </Button>
    </CenterWrapper>
  </Menu>
  
  );
};

export default CategorySearch;
